/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GetCollaborationToolTemplateResponseDto = {
    type: GetCollaborationToolTemplateResponseDto.type;
};

export namespace GetCollaborationToolTemplateResponseDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
